export default "__VITE_ASSET__DrmcsQd3__"